// extracted by mini-css-extract-plugin
module.exports = {"icon":"NavigationMenuHomeIcon__icon___1JsTS","tpbIcon":"NavigationMenuHomeIcon__tpbIcon___3IkeJ"};